import SealinkReducer from './sealink_reducer';

export default SealinkReducer;
